import { enCA, frCA } from 'date-fns/locale';
import { LocaleRegistration } from 'src/app/core/di/locale.token';

export const therAppyLocales = new Map<string, LocaleRegistration>([
  ['en', { title: 'English', dateLocale: enCA }],
  ['fr', { title: 'Français', dateLocale: frCA }],
]);
